import { presentationApi } from "api/immunization";
import MasterListScreen from "./common/MasterListScreen";
import VaccinePresentationModal from "./VaccinePresentationModal";

const VaccinePresentationList = ({ searchText = "" }) => (
  <MasterListScreen
    resource={presentationApi}
    label="Vaccine presentation"
    entityLabel="vaccine presentation"
    addLabel="Add Presentation"
    tag="immunization-presentation"
    headers={[
      "Name",
      "Code",
      "Multi Dose",
      "Doses / Vial",
      "Reconstitution",
      "Status",
      "Action",
    ]}
    keys={[
      "name",
      "code",
      "multiDoseLabel",
      "defaultDosesPerVial",
      "reconstitutionLabel",
      "statusChip",
      "action",
    ]}
    displayName={(item) => item.display}
    mapRow={(item) => ({
      multiDoseLabel: item.isMultiDose ? "Yes" : "No",
      reconstitutionLabel: item.requiresReconstitution ? "Required" : "—",
    })}
    Modal={VaccinePresentationModal}
    searchText={searchText}
  />
);

export default VaccinePresentationList;
